import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, forkJoin, Observable, of, throwError } from "rxjs";
import { catchError, finalize, map, switchMap, take, tap } from "rxjs/operators";
import { EStatus } from "src/app/models/general-enums";
import { SiteService } from "src/app/new-sites-management/common/services/site.service";
import { ECategoryTypes, EMenuType } from "../models/enums";

@Injectable({
    providedIn: 'root'
})
export class SiteMenuService {

    constructor(
        private http: HttpClient,
        private siteService: SiteService) {
        forkJoin([
            this.getMenuGroups(),
            this.getMenuCategories()])
            .subscribe();

        siteService.isSiteChanged$.subscribe(
            () => {
                this.updateMenus()
            }
        )
    }

    private MenuGroupsSubject = new BehaviorSubject<iSiteMenuGroup[]>(null);
    MenuGroups$: Observable<iSiteMenuGroup[]> = this.MenuGroupsSubject.asObservable();

    private groupsLoadingSubject = new BehaviorSubject<boolean>(false);
    groupsLoading$: Observable<boolean> = this.groupsLoadingSubject.asObservable();

    private menuCategoriesSubject = new BehaviorSubject<iCategory[]>(null);
    menuCategories$: Observable<iCategory[]> = this.menuCategoriesSubject.asObservable();

    private categoriesLoadinSubject = new BehaviorSubject<boolean>(false);
    categoriesLoadin$: Observable<boolean> = this.categoriesLoadinSubject.asObservable();

    getMenuCategories(): Observable<iCategory[]> {
        this.categoriesLoadinSubject.next(true);
        return this.menuCategories$
            .pipe(
                take(1),
                switchMap((categories) => {
                    if (categories) {
                        return of(categories)
                    }
                    else {
                        // return this.http.get<iCategory[]>(`/Categories/GetCategoriesByTypeId/${ECategoryTypes.Menu}`)
                        
                        return this.http.get<iCategory[]>(`/CategoriesApi/GetCategoriesByTypeId/${ECategoryTypes.Menu}`)
                            // .pipe(
                            //     map((res) => res && res.map(item => ({

                            //         id: item.id,
                            //         name: item.name,
                            //         status: item.status
                            //     }) as iCategory)),
                            // )
                            .pipe(
                                map((res) => res&&res.map((item) => { 
                                    return item = {id:item.id , name:item.categoryDetails[0].name , status:item.status}
                                }))
                            )
                    }
                }),
                tap((categories) => categories && this.menuCategoriesSubject.next(categories)),
                catchError((err) => {
                    throwError(err);
                    return of([]);
                }),
                finalize(() => this.categoriesLoadinSubject.next(false))
            )

    }

    resetMenuCategory() {
        this.menuCategoriesSubject.next(null);
        return of(true)
    }

    //#region menugroups
    getMenuGroups(isNew?): Observable<iSiteMenuGroup[]> {
        this.groupsLoadingSubject.next(true);
        if(isNew)
         this.MenuGroupsSubject.next(null)
        return this.MenuGroupsSubject.pipe(
            take(1),
            switchMap((groups: iSiteMenuGroup[]) => {
                if (groups) {
                    return of(groups)
                }
                else {
                    return this.http.get<any[]>('/Menus/GetMenuGroups')
                        .pipe(
                            map(((res: any) => res && res.map(item => ({
                                id: item.id,
                                name: item.name,
                                status: item.status,
                                categoryName: item.category ? item.category.name : '',
                                categoryId: item.category ? item.category.id : 0,
                                categoryCulture: item.category && item.category.culture ? item.category.culture.id : 0,
                                categoryCultureCode: item.category && item.category.culture ? item.category.culture.cultureId : 0,
                                menuCount: item.menuItemsCount,
                                menus: item.menus.filter(m => m.status !== EStatus.Deleted).map(m => { return { ...m, slugTargetId: this.getSlugTargetId(m) } }),
                            }) as iSiteMenuGroup))),
                        )
                }
            }),
            tap((menuGroups: iSiteMenuGroup[]) => menuGroups && this.MenuGroupsSubject.next(menuGroups)),
            catchError((err) => {
                throwError(err);
                return of([]);
            }),
            finalize(() => this.groupsLoadingSubject.next(false))
        )
    }

    upsertMenuGroup(payload): Observable<iSiteMenuGroup> {
        return this.http.post<iSiteMenuGroup>('/Menus/UpsertMenuGroup', payload)


            .pipe(
                map((res: any) => res && ({

                    id: res.id,
                    name: res.name,
                    status: res.status,
                    categoryName: res.category.name,
                    categoryId: res.category.id,
                    categoryCulture: res.category.culture.id,
                    categoryCultureCode: res.category.culture.cultureId,
                    menuCount: res.menuItemsCount,

                    menus: []
                }) as iSiteMenuGroup),
                tap((group) => group && this.updateMenuGroup(payload.id === 0 ? 'add' : 'edit', group))
            )
    }

    duplicateMenuGroup(payload): Observable<iSiteMenuGroup> {
        return this.http.post<iSiteMenuGroup>(`/Menus/CloneMenuGroup`, payload)
            .pipe(
                map((res: any) => res && ({
                    id: res.id,
                    name: res.name,
                    status: res.status,
                    categoryName: res.category.name,
                    categoryId: res.category.id,
                    categoryCulture: res.category.culture.id,
                    categoryCultureCode: res.category.culture.cultureId,
                    menuCount: res.menuItemsCount
                }) as iSiteMenuGroup),
                tap((group) => group && this.updateMenuGroup('add', group))
            )
    }

    deleteMenuGroup(GroupId) {
        return this.http.get(`/Menus/DeleteMenuGroup/${GroupId}`)
            .pipe(
                tap((res) => res && this.updateMenuGroup('delete', GroupId))
            )
    }

    updateMenuGroup(method: string, group: iSiteMenuGroup | number) {
        let menuGroups;
        this.MenuGroups$.pipe(take(1)).subscribe(g => menuGroups = g);
        let index;

        switch (method) {
            case 'add':
                menuGroups.unshift(group)
                break;

            case 'edit':
                index = menuGroups.findIndex(g => g.id === (group as iSiteMenuGroup).id)
                menuGroups.splice(index, 1, (group as iSiteMenuGroup));
                break;

            case 'delete':
                index = menuGroups.findIndex(g => g.id === (group as number));
                menuGroups.splice(index, 1);
                break;
        }

        this.MenuGroupsSubject.next(menuGroups);
    }

    //#endregion

    //#region menu
    addMenuItem(payload) {
        return this.http.post('/Menus/AddMenu', payload)
            .pipe(
                switchMap(res => {
                    if (res) {
                        this.MenuGroupsSubject.next(null);
                        return this.getMenuGroups()
                    }
                })
            )
    }

    editMenuItem(id, payload) {
        return this.http.post(`/Menus/EditMenu/${id}`, payload)
            .pipe(
                switchMap(res => {
                    if (res) {
                        this.MenuGroupsSubject.next(null);
                        return this.getMenuGroups()
                    }
                })
            )
    }

    toggleMenuStatus(id, status) {
        return this.http.get(`/Menus/EditMenuStatus/${id}/${status}`)
            .pipe(
                switchMap(res => {
                    if (res) {
                        this.MenuGroupsSubject.next(null);
                        return this.getMenuGroups()
                    }
                })
            )
    }

    reorderMenu(payload) {
        return this.http.post<any>('/Menus/ChangeMenuSort',payload )
            .pipe(
                tap((res) => {
                    if (res) {
                        let menuGroups;
                        this.MenuGroups$.pipe(take(1)).subscribe(res => menuGroups = res);

                        let targetIndex = menuGroups.findIndex(x => x.id === payload.menuGroupId);
                        Object.assign(menuGroups[targetIndex], { menus: res })
                        this.MenuGroupsSubject.next(menuGroups)

                    }
                })
            )
    }
    //#endregion

    getAssignedRoles(menuId) {
        return this.http.get(`/Menus/GetMenuAssignedRoles/${menuId}`)
    }

    updateAssignedRoles(payload) {
        return this.http.post('/Menus/SaveMenuAssginedRoles', payload)
    }

    public getSlugTargetId(menu) {
        switch (menu.menuType) {
            case EMenuType.Page:
                return menu.pageId;

            case EMenuType.Post:
                return menu.postId;

            case EMenuType.Product:
                return menu.productId;

            default:
                return 0;

        }
        return menu.slugTargetId
    }

    updateMenus(){
        this.MenuGroupsSubject.next(null);
        this.menuCategoriesSubject.next(null);

        forkJoin([
            this.getMenuGroups(),
            this.getMenuCategories()])
            .subscribe();
    }

}

export interface iSiteMenuGroup {
    id: number;
    name: string;
    status: EStatus;
    categoryName: string;
    categoryId: number;
    categoryCulture: number;
    categoryCultureCode: string;
    menuCount: number;
    menus: any[]
}

export interface iCategory {
    id: number;
    name: string;
    status: EStatus;
    categoryDetails?:any;
}
